import { CreateBankAccountDto } from "../../../dtos/catalogs/bankAccount/CreateBankAccountDto";
import { BankAccountService } from "../../../services/catalogs/BankAccountService";
import React from "react";
import { BankAccountDetail } from "../../../components/Pages/Catalogs/BankAccount/BankAccountDetail";
import { IAppEntity } from "../../entities";
import { ReferenceTypes } from "../../../enums/ReferenceTypes";
import { NFLookupBankAccount } from "../../../components/Shared/NewForms/NFLookupBankAccount";
import BankAccountList from "../../../components/Pages/Catalogs/BankAccount/BankAccountList";

export const BankAccount: IAppEntity = {
  entityType: "catalog",
  title: "Bank Account",
  pluralTitle: "Bank Accounts",
  apiUrl: "BankAccounts",
  apiEnum: ReferenceTypes.CatalogBankAccount,
  getDetailViewComponent(
    model: any,
    modelUpdatedEvent: (model: any) => void
  ): any {
    return React.createElement(BankAccountDetail, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    });
  },
  getListView: (model: any, modelUpdatedEvent: (model: any) => void) =>
    React.createElement(BankAccountList, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    }),
  getLookupComponent(model: any): any {
    return React.createElement(NFLookupBankAccount, {
      fieldName: model.fieldName,
      title: model.title,
      setSelectedCatalog: model.setSelectedCatalog,
    });
  },
  getDataService() {
    return new BankAccountService(this.apiUrl);
  },
  getEmptyModel(): CreateBankAccountDto {
    return {
      name: "",
      uniqueCode: "",
      companyId: "",
      bankId: "",
      createdDate: new Date(),
      accountNo: "",
      accountNumber: 0,
      currencyId: "",
    };
  },
};
